import React, { Component } from "react";

class SponsorValue extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const price = this.props.price;
    return (
      <div className="child-detail__value child-detail__item">
        <p className="value__heading beta">What does my ${price} a month do?</p>
        <p className="value__content">
          Your monthly sponsorship donation will combine with other donations for maximum impact 
          in each community. You{"'"}ll help your child and other vulnerable children in the community 
          establish lasting access to life-changing basics like <strong>clean water, improved nutrition, 
          healthcare, quality education, economic opportunity, spiritual nurture and more.</strong>
        </p>
      </div>
    );
  }
}

export default SponsorValue;
